/**
 * Eyebrow — surtitre en capitales au-dessus d'un titre ou d'un groupe (SAAS-1182).
 *
 * @remarks
 * Un seul style, au lieu de 23 combinaisons taille / graisse / espacement
 * relevées pour 79 surtitres : `--text-eyebrow` (~11,5px à 15px), semibold,
 * `tracking-wider` — la combinaison déjà la plus fréquente.
 *
 * Ce n'est pas un titre : rendu en `<p>` par défaut. `as="h2"` quand le
 * surtitre est le seul intitulé d'une section (ex. en-tête de panneau). Jamais
 * le titre d'une vue : c'est `Heading level="page"` (`PageHeading`, `ListPage`,
 * `AdminFormPage`).
 */

import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

type EyebrowTag = 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface EyebrowProps extends HTMLAttributes<HTMLElement> {
  as?: EyebrowTag;
}

export function Eyebrow({ as: Tag = 'p', className, ...rest }: EyebrowProps) {
  return (
    <Tag
      className={cn(
        'text-eyebrow text-fg-muted m-0 font-semibold tracking-wider uppercase',
        className,
      )}
      {...rest}
    />
  );
}
